import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./assets/fonts/GothamPro/gothampro.ttf";
import "./assets/fonts/GothamPro/gothampro_bold.ttf";
import "./assets/fonts/GothamPro/gothampro_black.ttf";
import "./assets/fonts/GothamPro/gothampro_medium.ttf";
import "./assets/fonts/GothamPro/gothampro_light.ttf";
import "./assets/fonts/DinCondensed/DINCondensedBold.ttf";
import "./assets/fonts/Inter/Inter.ttf";

import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
